import { React } from 'Imports';
import { CSVLink } from 'react-csv';
import { ConfirmDialog } from '$Components/Shared/ConfirmDialog';
import { isEncompass } from '$Utilities/integrationPlatform';
import { useVideoEventExport } from '$Components/VideoEvents/VideoEventExport/useVideoEventExport';
import { VideoEventResponse } from '$Generated/api';
import { useAppSnackbar } from '$Utilities/hooks/useAppSnackbar';
import { AlertTypes } from '$Utilities/Enums/AlertTypes';

interface ExportEventDialogProps {
    open: boolean;
    videoEvent: VideoEventResponse;
    onClose: () => void;
    onSuccess: () => void;
}

const ExportEventDialog = (props: ExportEventDialogProps) => {
    const { open, videoEvent, onClose, onSuccess } = props;

    const { csvLinkRef, videoEventExportData, csvTitle, csvHeaders, downloadCsvSingle } = useVideoEventExport();
    const { showSnackbarMessage } = useAppSnackbar();

    const title = isEncompass ? 'Export Event Details' : 'Confirm Export';
    const message = 'Are you sure you want to export details for this event?';
    const cancelButtonText = isEncompass ? 'No, Go Back' : 'Cancel';
    const confirmButtonText = isEncompass ? 'Yes, Export' : 'Export';

    const handleSubmit = async () => {
        try {
            await downloadCsvSingle(videoEvent);
            onSuccess();
        } catch (error) {
            showSnackbarMessage({
                message: 'Unable to export details.',
                alertType: AlertTypes.Fail,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });
            onClose();
        }
    };

    return (
        <>
            <CSVLink ref={csvLinkRef} data={videoEventExportData} headers={csvHeaders} filename={`${csvTitle}.csv`} target="_blank" />
            <ConfirmDialog
                isOpen={open}
                title={title}
                contentMessage={message}
                cancelButton={cancelButtonText}
                acceptButton={confirmButtonText}
                handleModalClosed={onClose}
                handleSubmit={handleSubmit}
            />
        </>
    );
};

export default ExportEventDialog;
